import { SelectHTMLAttributes, forwardRef } from 'react';
import clsx from 'clsx';

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, ...rest }, ref) => (
    <select
      ref={ref}
      className={clsx(
        'h-10 w-full rounded-lg border border-border bg-surface px-3 text-sm text-text-primary transition-colors',
        'hover:border-border-strong focus:border-primary focus:outline-none focus:ring-4 focus:ring-primary-soft',
        className,
      )}
      {...rest}
    >
      {children}
    </select>
  ),
);
Select.displayName = 'Select';
